import DBrokerDealerDetailPage from './DBrokerDealerDetailPage'

export default DBrokerDealerDetailPage
